<template>
    <Popup v-model="show" title="Earned_Details" v-model:refresh="state.refreshing" @refresh="refresh" :empty="list.finished && !list.data.length">
        <template #title>
            <div class="list-title" v-for="item in titleList" :key="item">{{ $t(item) }}</div>
        </template>
        <van-list v-model:loading="list.loading" :finished="list.finished" :loading-text="$t('Loading_please_wait')" @load="onLoad">
            <div class="list-item" v-for="(item, index) in list.data" :key="index">
                <div>{{ dayjs(item.time).format('YYYY-MM-DD HH:mm:ss') }}</div>
                <div>{{ item.uid }}</div>
                <!-- 类型多语言使用 类型代码比如 type 加_earncash如 invite_earncash -->
                <div>{{ $t(`earncash.${item.type}_earncash`) }}</div>
                <div>+{{ store.cureencySymbol(item.currency) }} {{ formatNumber(item.income) }}</div>
            </div>
        </van-list>
    </Popup>
</template>
<script lang="ts" setup>
import { usePagation } from '@/hooks/usePagation'
import { getEarnLogs } from '@/api/earnCash'
import { formatNumber } from '@/utils/toolsValidate'
import dayjs from 'dayjs'
import Popup from '@/components/earnMoney/popup.vue'
import { useBaseStore } from '@/stores'

const { list, start } = usePagation()
const store = useBaseStore()

const show = defineModel()
const state = reactive({
    refreshing: false,
    empty: false,
})
const titleList = ['Time', 'ID', 'earncash.Earned_type', 'earncash.Earned_contribution']

const onLoad = async () => {
    list.loading = true
    try {
        const res = await getEarnLogs({ from: start.value, size: list.pageSize })
        if (res.code === 200) {
            if (state.refreshing) {
                list.data = [...res.data]
            } else {
                list.data = [...list.data, ...res.data]
            }
            if (list.data.length >= res.total) {
                list.finished = true
            }
        }
    } catch (e) {
        list.finished = true
    } finally {
        list.loading = false
        list.pageNum++
    }
}

const refresh = async () => {
    state.refreshing = true
    list.pageNum = 1
    list.finished = false
    await onLoad()
    state.refreshing = false
}
</script>
<style lang="scss" scoped>
@use './common.scss' as *;
.common-pop {
    height: 1253px;
}
.list-title {
    flex: 1;

    &:first-child {
        flex: 0 0 180px;
        text-align: left;
    }
    &:last-child {
        text-align: right;
    }
}
.list-item {
    div {
        &:first-child {
            text-align: left;
            flex: 0 0 180px;
        }
        &:last-child {
            color: #10c580;
            text-align: right;
        }
    }
}
</style>
